import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { ApiEndpoints } from '@app/utils/enums/api-endpoints';
import { LockPayload } from '@app/utils/interfaces/lock.interface';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class LockService {
  private readonly baseUrl = environment.apiBaseUrl;
  private readonly httpClient = inject(HttpClient);

  public lock(payload: LockPayload): Observable<void> {
    return this.httpClient.post<void>(`${this.baseUrl}${ApiEndpoints.POST_LOCK}`, payload);
  }

  public refreshLock(payload: LockPayload): Observable<void> {
    return this.httpClient.put<void>(`${this.baseUrl}${ApiEndpoints.PUT_REFRESH_LOCK}`, payload);
  }

  public deleteLock(payload: LockPayload): Observable<void> {
    return this.httpClient.delete<void>(`${this.baseUrl}${ApiEndpoints.DELETE_LOCK}`, {
      body: payload,
    });
  }

  public check(payload: LockPayload): Observable<boolean> {
    return this.httpClient.post<boolean>(`${this.baseUrl}${ApiEndpoints.POST_CHECK_LOCK}`, payload);
  }
}
